import React, { ComponentPropsWithoutRef } from 'react';
import { InlineCode, makeStyles } from '@rbx/ui';

const useMarkdownInlineCodeStyles = makeStyles()(() => ({
  inlineCode: {
    fontSize: 'inherit',
    fontWeight: 'inherit',
  },
}));

export type MarkdownInlineCodeProps = ComponentPropsWithoutRef<typeof InlineCode> & {
  className?: string;
};

export default function MarkdownSimpleInlineCode({ children, className }: MarkdownInlineCodeProps) {
  const {
    classes: { inlineCode },
    cx,
  } = useMarkdownInlineCodeStyles();

  return (
    <InlineCode
      classes={{
        root: cx(inlineCode, className),
      }}>
      {children?.toString()}
    </InlineCode>
  );
}
